@if (!isFilterBuilder) {
  <div class="row">
    @if (componentRelationshipFilters && config_ready) {
      <select-many-search-component
        (selectionChangeComplete)="loadRelatedProperties($event)"
        [api_model]="'component_type'"
        [custom_filters]="componentRelationshipFilters"
        [value]="selectedRelatedComponentTypes"
        [removeItemDisabled]="isRelatedComponentTypeDisabled.bind(this)"
        label="Load related properties for:"
        class="select-search select-many-search-wrapper">
      </select-many-search-component>
    }
  </div>
}

@if (config_ready) {
  <wire-query-builder [config]="config"
    [query]="query"
    (queryChange)="onQueryChange($event)"
    [modelTypeId]="modelTypeId"
    [additionalFields]="additionalFields"
    class="query-builder">
  </wire-query-builder>
}
